import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Upgrades
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type UpgradesParameters = UpgradesCheckoutScreenOpenendParameters | UpgradesContinueToPaymentClickedParameters | UpgradesProductsScreenOpenendParameters | UpgradesSubscriptionCreatedParameters | UpgradesSubscriptionUpgradedParameters | UpgradesSubscriptionDowngradedParameters | UpgradesTrialbannerCtaSelectedParameters | UpgradesScheduledemoPageSelectedParameters | UpgradesScheduledemoPageOpenedParameters | UpgradesScheduledemoBannerpopupOpenedParameters | UpgradesScheduledemoBannerpopupButtonSelectedParameters | UpgradesPaywallheaderStartproSelectedParameters | UpgradesPaywallheaderExploreSelectedParameters | UpgradesPaywallheaderdialogClosedParameters | UpgradesPaywallheaderdialogUpSelectedParameters | UpgradesPaywallheaderdialogDmSelectedParameters;
export type UpgradesEvents = UpgradesCheckoutScreenOpenendEvent | UpgradesContinueToPaymentClickedEvent | UpgradesProductsScreenOpenendEvent | UpgradesSubscriptionCreatedEvent | UpgradesSubscriptionUpgradedEvent | UpgradesSubscriptionDowngradedEvent | UpgradesTrialbannerCtaSelectedEvent | UpgradesScheduledemoPageSelectedEvent | UpgradesScheduledemoPageOpenedEvent | UpgradesScheduledemoBannerpopupOpenedEvent | UpgradesScheduledemoBannerpopupButtonSelectedEvent | UpgradesPaywallheaderStartproSelectedEvent | UpgradesPaywallheaderExploreSelectedEvent | UpgradesPaywallheaderdialogClosedEvent | UpgradesPaywallheaderdialogUpSelectedEvent | UpgradesPaywallheaderdialogDmSelectedEvent;

export interface UpgradesCheckoutScreenOpenendParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	mobileScreenSize: boolean; // is the screen width below the mobile screen threshold
}

export type UpgradesCheckoutScreenOpenendParametersSpecific = Omit<
	UpgradesCheckoutScreenOpenendParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesCheckoutScreenOpenendParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesCheckoutScreenOpenendEventBuilder {
	constructor(private specificParameters: UpgradesCheckoutScreenOpenendParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesCheckoutScreenOpenendParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesCheckoutScreenOpenendParametersSpecific,
            UpgradesCheckoutScreenOpenendParameters,
			(params: UpgradesCheckoutScreenOpenendParameters) => UpgradesCheckoutScreenOpenendEvent
		>(this.specificParameters, upgradesCheckoutScreenOpenendParametersGlobal, globalParams, (params) => new UpgradesCheckoutScreenOpenendEvent(params));
	}
}

/**
 * A user has opened the checkout screen
 */
export class UpgradesCheckoutScreenOpenendEvent extends CraftnoteEvent<UpgradesCheckoutScreenOpenendParameters>{
  constructor(parameters: UpgradesCheckoutScreenOpenendParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_checkout_screen_openend"
		},
		{
			name: "iterable",
			eventName: "upgrades_checkout_screen_openend"
		},
	]);
  }
}
export interface UpgradesContinueToPaymentClickedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	mobileScreenSize: boolean; // is the screen width below the mobile screen threshold
}

export type UpgradesContinueToPaymentClickedParametersSpecific = Omit<
	UpgradesContinueToPaymentClickedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesContinueToPaymentClickedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesContinueToPaymentClickedEventBuilder {
	constructor(private specificParameters: UpgradesContinueToPaymentClickedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesContinueToPaymentClickedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesContinueToPaymentClickedParametersSpecific,
            UpgradesContinueToPaymentClickedParameters,
			(params: UpgradesContinueToPaymentClickedParameters) => UpgradesContinueToPaymentClickedEvent
		>(this.specificParameters, upgradesContinueToPaymentClickedParametersGlobal, globalParams, (params) => new UpgradesContinueToPaymentClickedEvent(params));
	}
}

/**
 * A user has clicked the 'continue to payment details' button
 */
export class UpgradesContinueToPaymentClickedEvent extends CraftnoteEvent<UpgradesContinueToPaymentClickedParameters>{
  constructor(parameters: UpgradesContinueToPaymentClickedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_continue_to_payment_clicked"
		},
		{
			name: "iterable",
			eventName: "upgrades_continue_to_payment_clicked"
		},
	]);
  }
}
export interface UpgradesProductsScreenOpenendParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	mobileScreenSize: boolean; // is the screen width below the mobile screen threshold
}

export type UpgradesProductsScreenOpenendParametersSpecific = Omit<
	UpgradesProductsScreenOpenendParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesProductsScreenOpenendParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesProductsScreenOpenendEventBuilder {
	constructor(private specificParameters: UpgradesProductsScreenOpenendParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesProductsScreenOpenendParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesProductsScreenOpenendParametersSpecific,
            UpgradesProductsScreenOpenendParameters,
			(params: UpgradesProductsScreenOpenendParameters) => UpgradesProductsScreenOpenendEvent
		>(this.specificParameters, upgradesProductsScreenOpenendParametersGlobal, globalParams, (params) => new UpgradesProductsScreenOpenendEvent(params));
	}
}

/**
 * A user has opened the products screen
 */
export class UpgradesProductsScreenOpenendEvent extends CraftnoteEvent<UpgradesProductsScreenOpenendParameters>{
  constructor(parameters: UpgradesProductsScreenOpenendParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_products_screen_openend"
		},
		{
			name: "iterable",
			eventName: "upgrades_products_screen_openend"
		},
	]);
  }
}
export interface UpgradesSubscriptionCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	mobileScreenSize: boolean; // is the screen width below the mobile screen threshold
}

export type UpgradesSubscriptionCreatedParametersSpecific = Omit<
	UpgradesSubscriptionCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesSubscriptionCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesSubscriptionCreatedEventBuilder {
	constructor(private specificParameters: UpgradesSubscriptionCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesSubscriptionCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesSubscriptionCreatedParametersSpecific,
            UpgradesSubscriptionCreatedParameters,
			(params: UpgradesSubscriptionCreatedParameters) => UpgradesSubscriptionCreatedEvent
		>(this.specificParameters, upgradesSubscriptionCreatedParametersGlobal, globalParams, (params) => new UpgradesSubscriptionCreatedEvent(params));
	}
}

/**
 * A user subscribed to Craftnote.
 */
export class UpgradesSubscriptionCreatedEvent extends CraftnoteEvent<UpgradesSubscriptionCreatedParameters>{
  constructor(parameters: UpgradesSubscriptionCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "subscription_wizardSummaryStepConfirm_su"
		},
		{
			name: "iterable",
			eventName: "upgrades_subscription_created"
		},
	]);
  }
}
export interface UpgradesSubscriptionUpgradedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesSubscriptionUpgradedParametersSpecific = Omit<
	UpgradesSubscriptionUpgradedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesSubscriptionUpgradedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesSubscriptionUpgradedEventBuilder {
	constructor(private specificParameters: UpgradesSubscriptionUpgradedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesSubscriptionUpgradedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesSubscriptionUpgradedParametersSpecific,
            UpgradesSubscriptionUpgradedParameters,
			(params: UpgradesSubscriptionUpgradedParameters) => UpgradesSubscriptionUpgradedEvent
		>(this.specificParameters, upgradesSubscriptionUpgradedParametersGlobal, globalParams, (params) => new UpgradesSubscriptionUpgradedEvent(params));
	}
}

/**
 * A user upgraded the subscription.
 */
export class UpgradesSubscriptionUpgradedEvent extends CraftnoteEvent<UpgradesSubscriptionUpgradedParameters>{
  constructor(parameters: UpgradesSubscriptionUpgradedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "subscription_upgrade_success"
		},
		{
			name: "iterable",
			eventName: "upgrades_subscription_upgraded"
		},
	]);
  }
}
export interface UpgradesSubscriptionDowngradedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesSubscriptionDowngradedParametersSpecific = Omit<
	UpgradesSubscriptionDowngradedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesSubscriptionDowngradedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesSubscriptionDowngradedEventBuilder {
	constructor(private specificParameters: UpgradesSubscriptionDowngradedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesSubscriptionDowngradedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesSubscriptionDowngradedParametersSpecific,
            UpgradesSubscriptionDowngradedParameters,
			(params: UpgradesSubscriptionDowngradedParameters) => UpgradesSubscriptionDowngradedEvent
		>(this.specificParameters, upgradesSubscriptionDowngradedParametersGlobal, globalParams, (params) => new UpgradesSubscriptionDowngradedEvent(params));
	}
}

/**
 * A user downgraded the subscription.
 */
export class UpgradesSubscriptionDowngradedEvent extends CraftnoteEvent<UpgradesSubscriptionDowngradedParameters>{
  constructor(parameters: UpgradesSubscriptionDowngradedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "subscription_downgrade_success"
		},
		{
			name: "iterable",
			eventName: "upgrades_subscription_downgraded"
		},
	]);
  }
}
export interface UpgradesTrialbannerCtaSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesTrialbannerCtaSelectedParametersSpecific = Omit<
	UpgradesTrialbannerCtaSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesTrialbannerCtaSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesTrialbannerCtaSelectedEventBuilder {
	constructor(private specificParameters: UpgradesTrialbannerCtaSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesTrialbannerCtaSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesTrialbannerCtaSelectedParametersSpecific,
            UpgradesTrialbannerCtaSelectedParameters,
			(params: UpgradesTrialbannerCtaSelectedParameters) => UpgradesTrialbannerCtaSelectedEvent
		>(this.specificParameters, upgradesTrialbannerCtaSelectedParametersGlobal, globalParams, (params) => new UpgradesTrialbannerCtaSelectedEvent(params));
	}
}

/**
 * A user clicked on the upgrade button in the trial banner.
 */
export class UpgradesTrialbannerCtaSelectedEvent extends CraftnoteEvent<UpgradesTrialbannerCtaSelectedParameters>{
  constructor(parameters: UpgradesTrialbannerCtaSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "trial_banner_dialog_upgrade_options"
		},
		{
			name: "iterable",
			eventName: "upgrades_trialbanner_cta_selected"
		},
	]);
  }
}
export interface UpgradesScheduledemoPageSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	demoType: string; // Type of the demo button selected, possible values are "sidebar" or "trial-banner"
	totalCompanyMembers: number; // The count of the company members
}

export type UpgradesScheduledemoPageSelectedParametersSpecific = Omit<
	UpgradesScheduledemoPageSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesScheduledemoPageSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesScheduledemoPageSelectedEventBuilder {
	constructor(private specificParameters: UpgradesScheduledemoPageSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesScheduledemoPageSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesScheduledemoPageSelectedParametersSpecific,
            UpgradesScheduledemoPageSelectedParameters,
			(params: UpgradesScheduledemoPageSelectedParameters) => UpgradesScheduledemoPageSelectedEvent
		>(this.specificParameters, upgradesScheduledemoPageSelectedParametersGlobal, globalParams, (params) => new UpgradesScheduledemoPageSelectedEvent(params));
	}
}

/**
 * A user clicked on the button in the sidebar and opened the page to schedule a demo.
 */
export class UpgradesScheduledemoPageSelectedEvent extends CraftnoteEvent<UpgradesScheduledemoPageSelectedParameters>{
  constructor(parameters: UpgradesScheduledemoPageSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "schedule_demo_sidebar_button_clicked"
		},
		{
			name: "iterable",
			eventName: "upgrades_scheduledemo_page_selected"
		},
	]);
  }
}
export interface UpgradesScheduledemoPageOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	demoType: string; // Type of the demo button selected, possible values are "sidebar" or "trial-banner"
	totalCompanyMembers: number; // The count of the company members
}

export type UpgradesScheduledemoPageOpenedParametersSpecific = Omit<
	UpgradesScheduledemoPageOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesScheduledemoPageOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesScheduledemoPageOpenedEventBuilder {
	constructor(private specificParameters: UpgradesScheduledemoPageOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesScheduledemoPageOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesScheduledemoPageOpenedParametersSpecific,
            UpgradesScheduledemoPageOpenedParameters,
			(params: UpgradesScheduledemoPageOpenedParameters) => UpgradesScheduledemoPageOpenedEvent
		>(this.specificParameters, upgradesScheduledemoPageOpenedParametersGlobal, globalParams, (params) => new UpgradesScheduledemoPageOpenedEvent(params));
	}
}

/**
 * A user clicked on the button in the page to schedule a demo with calendly.
 */
export class UpgradesScheduledemoPageOpenedEvent extends CraftnoteEvent<UpgradesScheduledemoPageOpenedParameters>{
  constructor(parameters: UpgradesScheduledemoPageOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "schedule_demo_sidebar_calendly_red"
		},
		{
			name: "iterable",
			eventName: "upgrades_scheduledemo_page_opened"
		},
	]);
  }
}
export interface UpgradesScheduledemoBannerpopupOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	demoType: string; // Type of the demo button selected, possible values are "sidebar" or "trial-banner"
	totalCompanyMembers: number; // The count of the company members
}

export type UpgradesScheduledemoBannerpopupOpenedParametersSpecific = Omit<
	UpgradesScheduledemoBannerpopupOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesScheduledemoBannerpopupOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesScheduledemoBannerpopupOpenedEventBuilder {
	constructor(private specificParameters: UpgradesScheduledemoBannerpopupOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesScheduledemoBannerpopupOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesScheduledemoBannerpopupOpenedParametersSpecific,
            UpgradesScheduledemoBannerpopupOpenedParameters,
			(params: UpgradesScheduledemoBannerpopupOpenedParameters) => UpgradesScheduledemoBannerpopupOpenedEvent
		>(this.specificParameters, upgradesScheduledemoBannerpopupOpenedParametersGlobal, globalParams, (params) => new UpgradesScheduledemoBannerpopupOpenedEvent(params));
	}
}

/**
 * A user clicked on the button in the top banner and opened the popup to schedule a demo.
 */
export class UpgradesScheduledemoBannerpopupOpenedEvent extends CraftnoteEvent<UpgradesScheduledemoBannerpopupOpenedParameters>{
  constructor(parameters: UpgradesScheduledemoBannerpopupOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "schedule_demo_t_banner_button_clicked"
		},
		{
			name: "iterable",
			eventName: "upgrades_scheduledemo_bannerpopup_opened"
		},
	]);
  }
}
export interface UpgradesScheduledemoBannerpopupButtonSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	demoType: string; // Type of the demo button selected, possible values are "sidebar" or "trial-banner"
	totalCompanyMembers: number; // The count of the company members
}

export type UpgradesScheduledemoBannerpopupButtonSelectedParametersSpecific = Omit<
	UpgradesScheduledemoBannerpopupButtonSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesScheduledemoBannerpopupButtonSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesScheduledemoBannerpopupButtonSelectedEventBuilder {
	constructor(private specificParameters: UpgradesScheduledemoBannerpopupButtonSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesScheduledemoBannerpopupButtonSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesScheduledemoBannerpopupButtonSelectedParametersSpecific,
            UpgradesScheduledemoBannerpopupButtonSelectedParameters,
			(params: UpgradesScheduledemoBannerpopupButtonSelectedParameters) => UpgradesScheduledemoBannerpopupButtonSelectedEvent
		>(this.specificParameters, upgradesScheduledemoBannerpopupButtonSelectedParametersGlobal, globalParams, (params) => new UpgradesScheduledemoBannerpopupButtonSelectedEvent(params));
	}
}

/**
 * A user clicked on the button in the popup to schedule a demo with calendly.
 */
export class UpgradesScheduledemoBannerpopupButtonSelectedEvent extends CraftnoteEvent<UpgradesScheduledemoBannerpopupButtonSelectedParameters>{
  constructor(parameters: UpgradesScheduledemoBannerpopupButtonSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "schedule_demo_t_banner_calendly_red"
		},
		{
			name: "iterable",
			eventName: "upgrades_scheduledemo_bannerpopup_button_selected"
		},
	]);
  }
}
export interface UpgradesPaywallheaderStartproSelectedParameters {
	version: string; // version of the mobile or web app.
	companyId: string; // ID of the current user's company.
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesPaywallheaderStartproSelectedParametersSpecific = Omit<
	UpgradesPaywallheaderStartproSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesPaywallheaderStartproSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesPaywallheaderStartproSelectedEventBuilder {
	constructor(private specificParameters: UpgradesPaywallheaderStartproSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesPaywallheaderStartproSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesPaywallheaderStartproSelectedParametersSpecific,
            UpgradesPaywallheaderStartproSelectedParameters,
			(params: UpgradesPaywallheaderStartproSelectedParameters) => UpgradesPaywallheaderStartproSelectedEvent
		>(this.specificParameters, upgradesPaywallheaderStartproSelectedParametersGlobal, globalParams, (params) => new UpgradesPaywallheaderStartproSelectedEvent(params));
	}
}

/**
 * A user clicked on the start pro button in the header.
 */
export class UpgradesPaywallheaderStartproSelectedEvent extends CraftnoteEvent<UpgradesPaywallheaderStartproSelectedParameters>{
  constructor(parameters: UpgradesPaywallheaderStartproSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_paywallheader_startpro_selected"
		},
		{
			name: "iterable",
			eventName: "upgrades_paywallheader_startpro_selected"
		},
	]);
  }
}
export interface UpgradesPaywallheaderExploreSelectedParameters {
	version: string; // version of the mobile or web app.
	companyId: string; // ID of the current user's company.
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesPaywallheaderExploreSelectedParametersSpecific = Omit<
	UpgradesPaywallheaderExploreSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesPaywallheaderExploreSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesPaywallheaderExploreSelectedEventBuilder {
	constructor(private specificParameters: UpgradesPaywallheaderExploreSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesPaywallheaderExploreSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesPaywallheaderExploreSelectedParametersSpecific,
            UpgradesPaywallheaderExploreSelectedParameters,
			(params: UpgradesPaywallheaderExploreSelectedParameters) => UpgradesPaywallheaderExploreSelectedEvent
		>(this.specificParameters, upgradesPaywallheaderExploreSelectedParametersGlobal, globalParams, (params) => new UpgradesPaywallheaderExploreSelectedEvent(params));
	}
}

/**
 * A user clicked on the explore pro button in the header.
 */
export class UpgradesPaywallheaderExploreSelectedEvent extends CraftnoteEvent<UpgradesPaywallheaderExploreSelectedParameters>{
  constructor(parameters: UpgradesPaywallheaderExploreSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_paywallheader_explore_selected"
		},
		{
			name: "iterable",
			eventName: "upgrades_paywallheader_explore_selected"
		},
	]);
  }
}
export interface UpgradesPaywallheaderdialogClosedParameters {
	version: string; // version of the mobile or web app.
	companyId: string; // ID of the current user's company.
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesPaywallheaderdialogClosedParametersSpecific = Omit<
	UpgradesPaywallheaderdialogClosedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesPaywallheaderdialogClosedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesPaywallheaderdialogClosedEventBuilder {
	constructor(private specificParameters: UpgradesPaywallheaderdialogClosedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesPaywallheaderdialogClosedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesPaywallheaderdialogClosedParametersSpecific,
            UpgradesPaywallheaderdialogClosedParameters,
			(params: UpgradesPaywallheaderdialogClosedParameters) => UpgradesPaywallheaderdialogClosedEvent
		>(this.specificParameters, upgradesPaywallheaderdialogClosedParametersGlobal, globalParams, (params) => new UpgradesPaywallheaderdialogClosedEvent(params));
	}
}

/**
 * A user clicked on the close button of explore pro dialog.
 */
export class UpgradesPaywallheaderdialogClosedEvent extends CraftnoteEvent<UpgradesPaywallheaderdialogClosedParameters>{
  constructor(parameters: UpgradesPaywallheaderdialogClosedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_paywallheaderdialog_closed"
		},
		{
			name: "iterable",
			eventName: "upgrades_paywallheaderdialog_closed"
		},
	]);
  }
}
export interface UpgradesPaywallheaderdialogUpSelectedParameters {
	version: string; // version of the mobile or web app.
	companyId: string; // ID of the current user's company.
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesPaywallheaderdialogUpSelectedParametersSpecific = Omit<
	UpgradesPaywallheaderdialogUpSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesPaywallheaderdialogUpSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesPaywallheaderdialogUpSelectedEventBuilder {
	constructor(private specificParameters: UpgradesPaywallheaderdialogUpSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesPaywallheaderdialogUpSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesPaywallheaderdialogUpSelectedParametersSpecific,
            UpgradesPaywallheaderdialogUpSelectedParameters,
			(params: UpgradesPaywallheaderdialogUpSelectedParameters) => UpgradesPaywallheaderdialogUpSelectedEvent
		>(this.specificParameters, upgradesPaywallheaderdialogUpSelectedParametersGlobal, globalParams, (params) => new UpgradesPaywallheaderdialogUpSelectedEvent(params));
	}
}

/**
 * A user clicked on the upgrade button of explore pro dialog.
 */
export class UpgradesPaywallheaderdialogUpSelectedEvent extends CraftnoteEvent<UpgradesPaywallheaderdialogUpSelectedParameters>{
  constructor(parameters: UpgradesPaywallheaderdialogUpSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_paywallheaderdialog_up_selected"
		},
		{
			name: "iterable",
			eventName: "upgrades_paywallheaderdialog_up_selected"
		},
	]);
  }
}
export interface UpgradesPaywallheaderdialogDmSelectedParameters {
	version: string; // version of the mobile or web app.
	companyId: string; // ID of the current user's company.
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type UpgradesPaywallheaderdialogDmSelectedParametersSpecific = Omit<
	UpgradesPaywallheaderdialogDmSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const upgradesPaywallheaderdialogDmSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class UpgradesPaywallheaderdialogDmSelectedEventBuilder {
	constructor(private specificParameters: UpgradesPaywallheaderdialogDmSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<UpgradesPaywallheaderdialogDmSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			UpgradesPaywallheaderdialogDmSelectedParametersSpecific,
            UpgradesPaywallheaderdialogDmSelectedParameters,
			(params: UpgradesPaywallheaderdialogDmSelectedParameters) => UpgradesPaywallheaderdialogDmSelectedEvent
		>(this.specificParameters, upgradesPaywallheaderdialogDmSelectedParametersGlobal, globalParams, (params) => new UpgradesPaywallheaderdialogDmSelectedEvent(params));
	}
}

/**
 * A user clicked on the demo button of explore pro dialog.
 */
export class UpgradesPaywallheaderdialogDmSelectedEvent extends CraftnoteEvent<UpgradesPaywallheaderdialogDmSelectedParameters>{
  constructor(parameters: UpgradesPaywallheaderdialogDmSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "upgrades_paywallheaderdialog_dm_selected"
		},
		{
			name: "iterable",
			eventName: "upgrades_paywallheaderdialog_dm_selected"
		},
	]);
  }
}
